export default "__VITE_ASSET__9d8c4d92__"